// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import AppLayout from "@/components/AppLayout";
// import api from "@/lib/api";
// import { useAuth } from "@/lib/auth";
// import { Card } from "@/components/ui/card";
// import { Button } from "@/components/ui/button";
// import { Textarea } from "@/components/ui/textarea";
// import { Label } from "@/components/ui/label";
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
// import { inrRange, locationLine } from "@/lib/format";
// import { TagList } from "@/components/shared/Tag";
// import GigStatusBadge from "@/components/shared/GigStatusBadge";
// import IndianNumberInput from "@/components/shared/IndianNumberInput";
// import { GIG_STATUS, ALLOWED_TRANSITIONS, isAcceptingApplications } from "@/lib/gig";
// import { toast } from "sonner";
// import { MapPin, Calendar as CalIcon, Clock, Users, Speaker, Lock, Edit3 } from "lucide-react";

// export default function OpportunityDetail() {
//   const { id } = useParams();
//   const nav = useNavigate();
//   const { account, activeProfile } = useAuth();
//   const [op, setOp] = useState(null);
//   const [notFound, setNotFound] = useState(false);
//   const [openApply, setOpenApply] = useState(false);
//   const [message, setMessage] = useState("");
//   const [rate, setRate] = useState(null);
//   const [applied, setApplied] = useState(false);

//   const load = () => api.get(`/opportunities/${id}`).then(({ data }) => setOp(data)).catch(() => setNotFound(true));
//   useEffect(() => { load(); }, [id]);

//   if (notFound) return <AppLayout><div className="py-20 text-center text-slate-500">Opportunity not found.</div></AppLayout>;
//   if (!op) return <AppLayout><div className="py-20 text-center text-slate-500">Loading…</div></AppLayout>;

//   const isOwner = account?.user_id === op.user_id;
//   const active = isAcceptingApplications(op);
//   const canEdit = isOwner && (op.application_count || 0) === 0 && !["completed", "cancelled"].includes(op.status);

//   const apply = async () => {
//     try {
//       await api.post("/applications", {
//         opportunity_id: id, profile_id: activeProfile?.profile_id,
//         message, proposed_rate: rate,
//       });
//       setApplied(true); setOpenApply(false);
//       toast.success("Application sent");
//     } catch (e) {
//       toast.error(e?.response?.data?.detail || "Failed");
//     }
//   };

//   const changeStatus = async (next) => {
//     try {
//       await api.patch(`/opportunities/${op.opportunity_id}/status`, { status: next });
//       toast.success("Status updated");
//       load();
//     } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
//   };

//   const transitions = ALLOWED_TRANSITIONS[op.status] || [];

//   return (
//     <AppLayout>
//       <button onClick={() => nav(-1)} className="text-sm text-slate-500 hover:text-slate-900">← Back</button>

//       <div className="mt-4 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6">
//         <Card className="p-8 border-slate-200">
//           <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider">
//             <span className="text-[#4F46E5]">{op.opportunity_type?.replace(/_/g, " ")}</span>
//             <GigStatusBadge status={op.status} testId="detail-status" />
//           </div>
//           <h1 className="mt-2 font-display text-3xl font-bold tracking-tight">{op.title}</h1>
//           <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
//             {op.poster_picture_url && <img src={op.poster_picture_url} className="w-6 h-6 rounded-full object-cover" alt="" />}
//             Posted by {op.poster_name}
//           </div>

//           <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
//             <div><CalIcon className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.date || "Flexible"}</div></div>
//             <div><Clock className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.start_time || "—"}{op.end_time ? ` – ${op.end_time}` : ""}</div></div>
//             <div><MapPin className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{locationLine(op) || "—"}</div></div>
//             <div><Users className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.performers_needed || 1} performer(s)</div></div>
//           </div>

//           <div className="mt-6 flex items-center gap-2 text-sm border border-slate-200 rounded-lg p-3 bg-slate-50 w-fit">
//             <Speaker className="w-4 h-4 text-slate-500" />
//             PA system: <b>{op.pa_system_provided ? "Provided" : "Not provided"}</b>
//           </div>

//           <div className="mt-8">
//             <h3 className="font-semibold">Description</h3>
//             <p className="mt-2 text-slate-700 leading-relaxed whitespace-pre-line">{op.description}</p>
//           </div>

//           {op.required_talent?.length > 0 && (
//             <div className="mt-6">
//               <h4 className="text-sm font-semibold text-slate-500 uppercase tracking-wider">Talent needed</h4>
//               <div className="mt-2"><TagList items={op.required_talent} tone="accent" /></div>
//             </div>
//           )}
//         </Card>

//         <aside className="space-y-4">
//           <Card className="p-6 border-slate-200">
//             <div className="text-xs uppercase text-slate-500 tracking-wider">Budget</div>
//             <div className="mt-1 font-display text-2xl font-bold">{inrRange(op.budget_min, op.budget_max)}</div>
//             {isOwner ? (
//               <div className="mt-4 space-y-2">
//                 <div className="text-xs text-slate-500">
//                   {op.application_count || 0} application(s) received
//                 </div>
//                 <Button variant="outline" onClick={() => nav(`/opportunities/${op.opportunity_id}/edit`)}
//                   disabled={!canEdit} data-testid="edit-gig"
//                   className="w-full justify-start">
//                   <Edit3 className="w-4 h-4 mr-1" /> {canEdit ? "Edit gig" : "Editing locked"}
//                 </Button>
//                 {!canEdit && (op.application_count || 0) > 0 && (
//                   <div className="text-xs text-slate-500">Editing is disabled once an application is received.</div>
//                 )}
//                 <div className="pt-3 mt-3 border-t border-slate-100">
//                   <Label className="text-xs font-semibold">Gig status</Label>
//                   <div className="mt-2 flex flex-wrap gap-2">
//                     {transitions.length === 0 && <span className="text-xs text-slate-500">No further transitions.</span>}
//                     {transitions.map((s) => (
//                       <Button key={s} size="sm" variant="outline" onClick={() => changeStatus(s)}
//                         data-testid={`transition-${s}`}>
//                         Move to {GIG_STATUS[s].label}
//                       </Button>
//                     ))}
//                   </div>
//                 </div>
//                 <Button className="mt-2 w-full" onClick={() => nav("/applications?role=poster")}>
//                   See applications
//                 </Button>
//               </div>
//             ) : (
//               <>
//                 <Button disabled={applied || !active} onClick={() => setOpenApply(true)} data-testid="apply-btn"
//                   className="w-full mt-4 bg-[#4F46E5] hover:bg-[#4338CA] text-white">
//                   {applied ? "Applied" : active ? "Apply" : "Applications closed"}
//                 </Button>
//                 <div className="mt-3 flex items-center gap-2 text-xs text-slate-500">
//                   <Lock className="w-3.5 h-3.5" />
//                   Contact information is revealed only after acceptance.
//                 </div>
//               </>
//             )}
//           </Card>
//         </aside>
//       </div>

//       <Dialog open={openApply} onOpenChange={setOpenApply}>
//         <DialogContent>
//           <DialogHeader><DialogTitle>Apply to {op.title}</DialogTitle></DialogHeader>
//           <div className="space-y-3">
//             <div>
//               <Label>Your message</Label>
//               <Textarea rows={4} value={message} onChange={(e) => setMessage(e.target.value)} data-testid="apply-message"
//                 placeholder="Introduce yourself and why you're a good fit." />
//             </div>
//             <div>
//               <Label>Proposed rate</Label>
//               <IndianNumberInput value={rate} onChange={setRate} testId="apply-rate" />
//             </div>
//           </div>
//           <DialogFooter>
//             <Button variant="outline" onClick={() => setOpenApply(false)}>Cancel</Button>
//             <Button onClick={apply} data-testid="apply-submit"
//               className="bg-[#4F46E5] hover:bg-[#4338CA] text-white">Send application</Button>
//           </DialogFooter>
//         </DialogContent>
//       </Dialog>
//     </AppLayout>
//   );
// }














import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { inrRange, locationLine } from "@/lib/format";
import { TagList } from "@/components/shared/Tag";
import GigStatusBadge from "@/components/shared/GigStatusBadge";
import IndianNumberInput from "@/components/shared/IndianNumberInput";
import { GIG_STATUS, ALLOWED_TRANSITIONS, isAcceptingApplications } from "@/lib/gig";
import { toast } from "sonner";
import { MapPin, Calendar as CalIcon, Clock, Users, Speaker, Lock, Edit3 } from "lucide-react";

export default function OpportunityDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { account, activeProfile } = useAuth();
  const [op, setOp] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [openApply, setOpenApply] = useState(false);
  const [message, setMessage] = useState("");
  const [rate, setRate] = useState(null);
  const [applied, setApplied] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/opportunities/${id}`);
      setOp(data);
      setNotFound(false);
    } catch {
      setNotFound(true);
    }
  }, [id]);

  useEffect(() => {
    load();

    const timer = setInterval(load, 15000);

    return () => clearInterval(timer);
  }, [load]);

  if (notFound) return <AppLayout><div className="py-20 text-center text-slate-500">Opportunity not found.</div></AppLayout>;
  if (!op) return <AppLayout><div className="py-20 text-center text-slate-500">Loading…</div></AppLayout>;

  const isOwner = account?.user_id === op.user_id;
  const active = isAcceptingApplications(op);
  const canEdit = isOwner && (op.application_count || 0) === 0 && !["completed", "cancelled"].includes(op.status);

  const apply = async () => {
    try {
      await api.post("/applications", {
        opportunity_id: id,
        profile_id: activeProfile?.profile_id,
        message,
        proposed_rate: rate,
      });
      setApplied(true);
      setOpenApply(false);
      toast.success("Application sent");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const changeStatus = async (next) => {
    try {
      await api.patch(`/opportunities/${op.opportunity_id}/status`, { status: next });
      toast.success("Status updated");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const transitions = ALLOWED_TRANSITIONS[op.status] || [];

  return (
    <AppLayout>
      <button onClick={() => nav(-1)} className="text-sm text-slate-500 hover:text-slate-900">← Back</button>

      <div className="mt-4 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6">
        <Card className="p-8 border-slate-200">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider">
            <span className="text-[#4F46E5]">{op.opportunity_type?.replace(/_/g, " ")}</span>
            <GigStatusBadge status={op.status} testId="detail-status" />
          </div>
          <h1 className="mt-2 font-display text-3xl font-bold tracking-tight">{op.title}</h1>
          <div className="mt-1 flex items-center gap-2 text-sm text-slate-500">
            {op.poster_picture_url && <img src={op.poster_picture_url} className="w-6 h-6 rounded-full object-cover" alt="" />}
            Posted by {op.poster_name}
          </div>

          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            <div><CalIcon className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.date || "Flexible"}</div></div>
            <div><Clock className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.start_time || "—"}{op.end_time ? ` – ${op.end_time}` : ""}</div></div>
            <div><MapPin className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{locationLine(op) || "—"}</div></div>
            <div><Users className="w-4 h-4 text-slate-400" /><div className="font-medium mt-1">{op.performers_needed || 1} performer(s)</div></div>
          </div>

          <div className="mt-6 flex items-center gap-2 text-sm border border-slate-200 rounded-lg p-3 bg-slate-50 w-fit">
            <Speaker className="w-4 h-4 text-slate-500" />
            PA system: <b>{op.pa_system_provided ? "Provided" : "Not provided"}</b>
          </div>

          <div className="mt-8">
            <h3 className="font-semibold">Description</h3>
            <p className="mt-2 text-slate-700 leading-relaxed whitespace-pre-line">{op.description}</p>
          </div>

          {op.required_talent?.length > 0 && (
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-slate-500 uppercase tracking-wider">Talent needed</h4>
              <div className="mt-2"><TagList items={op.required_talent} tone="accent" /></div>
            </div>
          )}
          {isOwner && transitions.includes("completed") && (
            <div className="mt-8 border-t border-slate-200 pt-6">
              <Button
                className="w-full"
                onClick={() => changeStatus("completed")}
                data-testid="mark-gig-complete"
              >
                Mark as Complete
              </Button>
            </div>
          )}
        </Card>

        <aside className="space-y-4">
          <Card className="p-6 border-slate-200">
            <div className="text-xs uppercase text-slate-500 tracking-wider">Budget</div>
            <div className="mt-1 font-display text-2xl font-bold">{inrRange(op.budget_min, op.budget_max)}</div>

            {isOwner ? (
              <div className="mt-4 space-y-2">
                <div className="text-xs text-slate-500">
                  {op.application_count || 0} application(s) received
                </div>

                <Button
                  variant="outline"
                  onClick={() => nav(`/opportunities/${op.opportunity_id}/edit`)}
                  disabled={!canEdit}
                  data-testid="edit-gig"
                  className="w-full justify-start"
                >
                  <Edit3 className="w-4 h-4 mr-1" /> {canEdit ? "Edit gig" : "Editing locked"}
                </Button>

                {!canEdit && (op.application_count || 0) > 0 && (
                  <div className="text-xs text-slate-500">
                    Editing is disabled once an application is received.
                  </div>
                )}

                <div className="pt-3 mt-3 border-t border-slate-100">
                  <Label className="text-xs font-semibold">Gig status</Label>

                  <div className="mt-2 flex flex-wrap gap-2">
                    {transitions.length === 0 && (
                      <span className="text-xs text-slate-500">No further transitions.</span>
                    )}

                    {transitions.filter((s) => s !== "completed").map((s) => (
                      <Button
                        key={s}
                        size="sm"
                        variant="outline"
                        onClick={() => changeStatus(s)}
                        data-testid={`transition-${s}`}
                      >
                        Move to {GIG_STATUS[s].label}
                      </Button>
                    ))}
                  </div>
                </div>

                <Button
                  className="mt-2 w-full"
                  onClick={() => nav("/applications?role=poster")}
                >
                  See applications
                </Button>
              </div>
            ) : (
              <>
                <Button
                  disabled={applied || !active}
                  onClick={() => setOpenApply(true)}
                  data-testid="apply-btn"
                  className="w-full mt-4 bg-[#4F46E5] hover:bg-[#4338CA] text-white"
                >
                  {applied ? "Applied" : active ? "Apply" : "Applications closed"}
                </Button>

                <div className="mt-3 flex items-center gap-2 text-xs text-slate-500">
                  <Lock className="w-3.5 h-3.5" />
                  Contact information is revealed only after acceptance.
                </div>
              </>
            )}
          </Card>
        </aside>
      </div>

      <Dialog open={openApply} onOpenChange={setOpenApply}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Apply to {op.title}</DialogTitle>
          </DialogHeader>

          <div className="space-y-3">
            <div>
              <Label>Your message</Label>
              <Textarea
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                data-testid="apply-message"
                placeholder="Introduce yourself and why you're a good fit."
              />
            </div>

            <div>
              <Label>Proposed rate</Label>
              <IndianNumberInput value={rate} onChange={setRate} testId="apply-rate" />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenApply(false)}>
              Cancel
            </Button>

            <Button
              onClick={apply}
              data-testid="apply-submit"
              className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
            >
              Send application
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </AppLayout>
  );
}